import { DropdownOption } from "PFComponents/dropdown/dropdown";
import Select from "PFComponents/select/select";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { WorkforceMetricsMode } from "../../../types";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "./workforce_metrics_mode_selector.module.scss";

interface WorkforceMetricsModeSelectorProps {
  disabled: boolean;
}

export const WorkforceMetricsModeSelector = ({
  disabled
}: WorkforceMetricsModeSelectorProps): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "workforce.metrics" });
  const { workforceMetricsMode, setWorkforceMetricsMode, showUtilizationMetrics } =
    useBookingsOverviewContext();

  const options: DropdownOption[] = useMemo(() => {
    if (showUtilizationMetrics) {
      return [
        {
          id: WorkforceMetricsMode.BillableUtilization,
          item: WorkforceMetricsMode.BillableUtilization,
          displayElement: t(`options.${WorkforceMetricsMode.BillableUtilization}`)
        },
        {
          id: WorkforceMetricsMode.TotalUtilization,
          item: WorkforceMetricsMode.TotalUtilization,
          displayElement: t(`options.${WorkforceMetricsMode.TotalUtilization}`)
        }
      ];
    } else {
      return [
        {
          id: WorkforceMetricsMode.TotalAvailability,
          item: WorkforceMetricsMode.TotalAvailability,
          displayElement: t(`options.${WorkforceMetricsMode.TotalAvailability}`)
        }
      ];
    }
  }, [showUtilizationMetrics, t]);

  const selectedIndex = options.findIndex(({ id }) => id === workforceMetricsMode);

  return options.length === 1 ? (
    <div className={css.singleOption}>{t(`displayOptions.${workforceMetricsMode}`)}</div>
  ) : (
    <Select
      //@ts-ignore
      selectedIndex={selectedIndex}
      value={t(`displayOptions.${workforceMetricsMode}`)}
      options={options}
      handleChange={setWorkforceMetricsMode}
      controlledValue
      noPadding
      readOnly
      inputFieldSetProps={{
        classes: {
          inputContainer: css.inputContainer,
          input: css.input,
          icon: css.icon
        }
      }}
      disabled={disabled}
    />
  );
};
